/** Careers & login imagery - hosted on careers.qiktruck.co.za */
const BASE = `${process.env.PUBLIC_URL || ""}/images/careers`;

export const CAREERS_MEDIA = {
  heroMain: `${BASE}/hero-main.jpg`,
  bannerTeam: `${BASE}/banner-team.jpg`,
  ctaBackground: `${BASE}/cta-background.jpg`,
  galleryAcademy: `${BASE}/gallery-academy.jpg`,
  galleryOperations: `${BASE}/gallery-operations.jpg`,
  galleryLeadership: `${BASE}/gallery-leadership.jpg`,
  stepSignin: `${BASE}/step-signin.jpg`,
  stepLearn: `${BASE}/step-learn.jpg`,
  stepPlacement: `${BASE}/step-placement.jpg`,
  featureTraining: `${BASE}/feature-training.jpg`,
  featureProgress: `${BASE}/feature-progress.jpg`,
  featureCareer: `${BASE}/feature-career.jpg`,
};

/** Per-program card and hero imagery */
export const ACADEMY_IMAGES = {
  driver: {
    src: `${BASE}/academy-driver.jpg`,
    alt: "South African truck driver training for QikTruck Driver Program",
    objectPosition: "center 35%",
  },
  operations: {
    src: `${BASE}/academy-operations.jpg`,
    alt: "Dispatch and control room training for QikTruck Operations Program",
    objectPosition: "center 30%",
  },
  leadership: {
    src: `${BASE}/academy-leadership.jpg`,
    alt: "Team leadership training for QikTruck Leadership Program",
    objectPosition: "center 35%",
  },
  business: {
    src: `${BASE}/academy-business.jpg`,
    alt: "Business and growth skills for QikTruck Business Program",
    objectPosition: "center center",
  },
  customer: {
    src: `${BASE}/academy-customer.jpg`,
    alt: "Customer service excellence for QikTruck Customer Program",
    objectPosition: "center 30%",
  },
};

/** Login page thumbnail strip - program learning paths */
export const LOGIN_THUMBS = [
  {
    src: CAREERS_MEDIA.galleryAcademy,
    alt: "Online logistics program learning on laptop",
    label: "Training programs",
  },
  {
    src: CAREERS_MEDIA.stepLearn,
    alt: "Completing a logistics training module",
    label: "Learn & certify",
  },
  {
    src: CAREERS_MEDIA.bannerTeam,
    alt: "Diverse South African logistics career candidates",
    label: "Career community",
  },
];

export const LANDING_STEPS = [
  {
    title: "Sign in & explore",
    text: "Create your profile with a one-time email code. Browse all five QikTruck Programs for free.",
    image: CAREERS_MEDIA.stepSignin,
    alt: "Sign in with email to access QikTruck Careers",
    objectPosition: "center center",
  },
  {
    title: "Learn & certify",
    text: "Complete modules, pass quizzes, and build a track record that recruiters can see.",
    image: CAREERS_MEDIA.stepLearn,
    alt: "Complete program modules and quizzes",
    objectPosition: "center 35%",
  },
  {
    title: "Get matched",
    text: "Apply for roles or get matched with logistics employers looking for trained candidates.",
    image: CAREERS_MEDIA.stepPlacement,
    alt: "Interview and placement with logistics employers",
    objectPosition: "center 30%",
  },
];

export const LANDING_FEATURES = [
  {
    title: "Free training programs",
    text: "Five career programs with modules, quizzes, and certificates - learn at your own pace on any device.",
    image: CAREERS_MEDIA.featureTraining,
    alt: "Free logistics programs on mobile",
    objectPosition: "center center",
  },
  {
    title: "Tracked progress",
    text: "Your learning is saved automatically. Pick up where you left off and show employers what you've completed.",
    image: CAREERS_MEDIA.featureProgress,
    alt: "Track program progress on your phone",
    objectPosition: "center center",
  },
  {
    title: "Path to placement",
    text: "Train first, then move through our hiring pipeline as you build real logistics competencies.",
    image: CAREERS_MEDIA.featureCareer,
    alt: "Career-ready logistics professional in South Africa",
    objectPosition: "center 25%",
  },
];

export const LANDING_GALLERY = [
  {
    src: CAREERS_MEDIA.galleryAcademy,
    alt: "Logistics program training online",
    label: "Program learning",
    objectPosition: "center 40%",
  },
  {
    src: CAREERS_MEDIA.galleryOperations,
    alt: "Warehouse and field operations training",
    label: "Field operations",
    objectPosition: "center 35%",
  },
  {
    src: CAREERS_MEDIA.galleryLeadership,
    alt: "Dispatch and operations control careers",
    label: "Operations & dispatch",
    objectPosition: "center 30%",
  },
];
